import React from 'react';
import { Clock, Leaf, Heart, ArrowDown } from 'lucide-react';
export function AboutSection() {
  return <section className="pt-6 md:pt-8 pb-16 md:pb-24 px-4 bg-white relative overflow-hidden" data-id="element-8" data-mp="2lbx0581jwovi">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl -z-10 transform -translate-x-1/2 -translate-y-1/2" data-id="element-9" data-mp="2gb8zdunisto3"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-forest/5 rounded-full blur-3xl -z-10 transform translate-x-1/3 translate-y-1/3" data-id="element-10" data-mp="27c5h2sw6gian"></div>

      <div className="max-w-4xl mx-auto" data-id="element-11" data-mp="22k48pi24rbpw">
        {/* Single column layout */}
        <div className="flex flex-col gap-10 items-center" data-id="element-12" data-mp="1xnnhug3jqj94">
          {/* Intro text block — always first */}
          

          {/* Image — second */}
          <div className="w-full max-w-md mx-auto relative" data-id="element-13" data-mp="1noesk0jmlst3">
            <div className="relative rounded-2xl overflow-hidden shadow-forest border-4 border-white transition-transform duration-500" data-id="element-14" data-mp="1nnwpajyjqebo">
              
              
              <div className="absolute bottom-4 left-4 right-4 text-white" data-id="element-15" data-mp="srszvghdqj15">
                <p className="font-serif font-bold text-xl" data-id="element-16" data-mp="xij6sy5getxy">Paola</p>
                <p className="text-sm opacity-90" data-id="element-17" data-mp="xkvwxyld8am3">
                  Creadora de Cenas Antiinflamatorias
                </p>
              </div>
            </div>

            {/* Decorative badge */}
            <div className="absolute -bottom-6 -right-6 bg-cream p-4 rounded-full shadow-warm border border-gold/20 hidden md:block" data-id="element-18" data-mp="nqwzhcw8lf0h">
              <Heart className="text-gold fill-gold/20" size={32} data-id="element-19" data-mp="1ghf2kdwyngdw" />
            </div>
          </div>

          {/* Rest of text — third */}
          <div className="w-full max-w-2xl mx-auto space-y-6 text-lg text-dark/80" data-id="element-20" data-mp="12h4a56g05tqm">
            <p data-id="element-21" data-mp="16ig1phifsp1g">
              Tenía 36 años cuando decidí que ya no podía seguir normalizando lo
              que mi cuerpo me decía.
            </p>

            <div className="bg-cream-dark/30 p-6 rounded-xl border-l-4 border-urgency/60 space-y-3 my-8" data-id="element-22" data-mp="3nahd233dt9qn">
              <p data-id="element-23" data-mp="1xqznaerhcqjv">El vientre hinchado de cada tarde.</p>
              <p data-id="element-24" data-mp="1xqg7b3le4c8h">El cansancio que no cedía aunque durmiera ocho horas.</p>
              <p data-id="element-25" data-mp="1srmrv5mjmb5o">Los kilos en el abdomen que no respondían a nada.</p>
              <p data-id="element-26" data-mp="1o16bbcnfe9f3">Despertarme a las 3 AM sin razón aparente.</p>
            </div>

            <p data-id="element-27" data-mp="1nytmqgn5x0t2">Comía bien. Ensaladas. Yogur. Pan integral. Todo lo correcto.</p>

            <p className="font-bold text-forest text-xl flex items-center gap-2" data-id="element-28" data-mp="1j1th26u8602h">
              Y mi cuerpo seguía respondiendo como si no. 🕯️
            </p>

            <p data-id="element-29" data-mp="1a15ce2qq1c29">
              Pasé dos años en consultas, planes nutricionales, suplementos y
              detox que no llegaron a ningún lado. Hasta que una noche — con
              Giacomo recién nacido en brazos y sin poder dormir — encontré la
              respuesta en la cronobiología nutricional.
            </p>

            <div className="space-y-4 my-8" data-id="element-30" data-mp="2zf1qglebyi6b">
              <div className="flex items-start gap-3" data-id="element-31" data-mp="2uh8m7xwl7y8o">
                <Clock className="text-gold shrink-0 mt-1" size={24} data-id="element-32" data-mp="2uhrwcsfzxic5" />
                <p data-id="element-33" data-mp="32z281fbcwt2g">
                  La ciencia que explica por qué después de las 7 PM tu cuerpo
                  no procesa los alimentos de la misma manera.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-34" data-mp="3bqaxg0ffoxos">
                <Leaf className="text-gold shrink-0 mt-1" size={24} data-id="element-35" data-mp="3bsx5e168lf7j" />
                <p data-id="element-36" data-mp="3gp5r5xexw6no">Por qué lo que de día es sano, de noche inflama.</p>
              </div>
              <div className="flex items-start gap-3" data-id="element-37" data-mp="2k0pxbp4srb4r">
                <Heart className="text-gold shrink-0 mt-1" size={24} data-id="element-38" data-mp="2o0qcjbzpzqcv" />
                <p data-id="element-39" data-mp="2o32tbltqruoc">Por qué esa última comida del día lo decide casi todo.</p>
              </div>
            </div>

            <p className="font-bold text-dark" data-id="element-40" data-mp="2xz657jeeb7oh">
              Apliqué esos principios en mi propia cocina. Con ingredientes
              normales. En 15 minutos.
            </p>

            <div className="bg-forest text-white p-6 rounded-xl shadow-md my-6 transform rotate-1" data-id="element-41" data-mp="8byg9cnxv0m7">
              <p className="font-serif text-xl md:text-2xl text-center" data-id="element-42" data-mp="db1mv1jkhewa">
                En una semana mi cuerpo empezó a mostrarme lo que había estado
                intentando hacer todo el tiempo. 🌿
              </p>
            </div>

            <p data-id="element-43" data-mp="1v73d6tdmhdm7">
              No soy médica ni nutricionista con título. Soy la mujer que
              encontró las respuestas que buscaba y no pudo quedárselas para
              ella sola.
            </p>

            <p className="font-medium" data-id="element-44" data-mp="253y7f02v4ruo">
              <strong className="text-forest" data-id="element-45" data-mp="252wzh4h58lh6">
                Cenas Antiinflamatorias en 15 Minutos
              </strong>{' '}
              nació de eso. De mi cocina. De mi cuerpo. De la necesidad real de
              tener en 15 minutos lo que a mí me costó dos años encontrar.
            </p>
          </div>
        </div>

        {/* Transition to Testimonials */}
      </div>
    </section>;
}